import { useWindowSize } from '@/hooks';
import { Tabs, TabsProps } from 'antd';
import { ReactNode } from 'react';

import './style.less';

function PageTabs({
  children,
  tabBarExtraContent,
  ...tabsProps
}: TabsProps & { tabBarExtraContent?: ReactNode }) {
  const { isMobile } = useWindowSize();
  return (
    <Tabs
      className="page-tabs"
      tabBarExtraContent={
        !isMobile && tabBarExtraContent ? (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {tabBarExtraContent}
          </div>
        ) : null
      }
      {...tabsProps}
    >
      {children}
    </Tabs>
  );
}

export default PageTabs;
